import { Tag } from '@tryhackme/thm-ui-components';
import type { FC } from 'react';
import type { InfluencerSubscriptionCampaignModalContentProps } from '../influencer-subscription-campaign-modal/influencer-subscription-campaign-modal.types';
import { StyledModalContainer, StyledTag } from './modal-content.styles';
export const SubscriptionContentModal: FC<InfluencerSubscriptionCampaignModalContentProps> = ({
  campaign,
  userFriendlyName
}) => {
  return <StyledModalContainer uppercaseTitle data-sentry-element="StyledModalContainer" data-sentry-component="SubscriptionContentModal" data-sentry-source-file="subscription-content.modal.tsx">
      <StyledTag data-sentry-element="StyledTag" data-sentry-source-file="subscription-content.modal.tsx">
        <Tag size="small" data-testid="campaign-title" data-sentry-element="Tag" data-sentry-source-file="subscription-content.modal.tsx">
          {userFriendlyName} Viewers Exclusive
        </Tag>
      </StyledTag>
      <h2>
        <span>{campaign?.amount}% off</span> on annual subscriptions!
      </h2>
      <p data-testid="campaign-promotion-text">You&apos;ve unlocked a {userFriendlyName} viewers exclusive offer!</p>
    </StyledModalContainer>;
};